<input pInputText type="text" [ngModel]="thirdPartyCode" name="thirdPartyCode" [disabled]="mode !== DetailMode.EDITION"
       (ngModelChange)="thirdPartyCodeChange.emit($event)" [maxLength]="8"
       [required]="required" pattern="(B|C|D|E|F|L|S):.+" class="acted-highlight-req metadata-field"
       [tabindex]="tabindex"/>
